import React  from 'react';
import '../StyleSheets/FinancialData.css';
import FinancialChart from './FinancialChart';
import GraphDataItem from './GraphDataItem';
import DropDown from './DropDown';
import gsap from 'gsap';


export default class FinancialData extends React.Component {
    
    constructor(props) {
        super(props);

        this.financialContRef = React.createRef();

        this.updateShowIndex = this.updateShowIndex.bind( this );

        const measures = Object.keys( props.coronaData.financial_data )
            .map( m => {
                return {
                    key: m,
                    title: props.coronaData.hebrew_legend[ m ].title,
                } 
            } 
        );

        const sampleData = this.props.coronaData.financial_data["s&p500"];
        const today = new Date();

        const periodOptions = [
            {key: sampleData[0].d, title: "כל התקופה" },
            {key: sampleData[sampleData.length - 2].d, title: "יממה אחרונה" },
            {key: "2/19/2020", title: "מאז 19-2-2020" },
            {key: "1/1/2020", title: "מאז 1-1-2020" },
            {key: global.addDays( today , -365 ), title: "שנה אחורה" },
        ];
        

        this.state = {
            
            measures: measures,
            measuresToShow: [true,false,false,false,true,false,false,false,false,true],

            periodOptions,
            currentPeriod: periodOptions[0].key,
        }
        
        
    }


    componentDidMount() {

        gsap.from(this.financialContRef.current, {y:200, opacity:0, duration: 0.8, ease:"power3.out"});

    }

    updateShowIndex( inx, isActive ) {
        
        const newActiveMeasures = []

        for(let i=0;i<Math.max( this.state.measuresToShow.length, inx + 1);i++) {
            if(i === inx) {
                newActiveMeasures[i] = isActive
            } else {
                newActiveMeasures[i] = this.state.measuresToShow[ i ]
            }
        }

        this.setState( { measuresToShow: newActiveMeasures } );

    }

    render() {
        const { appSettings, coronaData } = this.props;
        const { 
            measures,
            measuresToShow,
            periodOptions,
            currentPeriod,

        } = this.state;

        return (
            <div id="financialDataCont" ref={this.financialContRef}>
                <div id="financialTopToolbar">
                    <DropDown position={{x:"0",y:"0"}} icon={"date_range"} options={periodOptions} value={currentPeriod} onChange={(e)=>{ this.setState({currentPeriod: e.target.value}) }}/>
                </div>
                <section id="financialChartCont">
                    <h1 className="generalPanelTitle" style={{color:"#00000088", direction: "rtl", right:"0px"}}>מדדים פיננסיים נבחרים</h1>

                    <div key="financialGraphDataItemsContainer" id="financialGraphDataItemsContainer">
                        { 
                            measures.map((_,i) => {
                                return <GraphDataItem 
                                    key={i+_.key} 
                                    title={_.title} 
                                    color={ appSettings.colors[4 + i]} 
                                    isActive={ measuresToShow[ i ] } 
                                    onToggle={ a=>{this.updateShowIndex(i, a)}}
                                />
                            })
                        }
                    </div>
                    <FinancialChart 
                        useToolTips = {true}
                        data={{
                            measures: measures,
                            measuresToShow: measuresToShow,
                            colors: appSettings.colors.slice( 4 ),
                            coronaData: coronaData,
                            period: currentPeriod,
                        }}
                    />
                </section>
                <section id="financialCurrentStatusCont">
                <   h1 className="generalPanelTitle" style={{color:"#ffffff88", direction: "rtl", right:"0px", marginRight: "30px"}}>מצב עדכני <br/>ושינוי לתקופה</h1>
                    <div id="fcsItemsCont">
                        {measures.map( (m,i) => {
                            return <MeasureStatusItem 
                                key={"fcs_" +i} 
                                measure={m} 
                                data={coronaData.financial_data[m.key]}
                                color={ appSettings.colors[4+i] }
                                period={currentPeriod}
                            />
                        })}
                    </div>
                </section>
            </div>
        )

    }

}

function MeasureStatusItem(props) {

    const { measure, data, color, period } = props;

    const latestValue = data[data.length-1].v;
    let periodData = undefined;

    const periodStartingDate = new Date( period );

    let earliest = new Date();
    data.forEach( item => {
        const date = new Date( item.d );
        if( date < earliest && date >= periodStartingDate ) {
            periodData = item;
            earliest = date;
        }
    });

    let periodChangeString = "N/A";
    let changeColor = "ffffff88";

    if( periodData ) {
        const periodStartValue = periodData.v;
        const periodChange = 100 * (latestValue - periodStartValue) / periodStartValue;
        periodChangeString = periodChange.toFixed(2) + "%";
        
        changeColor = periodChange > 0 ? "#22ff88" : "#ff2244";
    }

    return (
        <div className="financialMeasureStatusItemCont" style={{backgroundColor: color+"22"}}>
            <div className="fmsiColor" style={{backgroundColor: color}}/>
            <div className="fmsiMeasureName">{measure.title}</div>
            <div className="fmsiMeasureValue">{latestValue}</div>
            <div className="fmsiChangeLabel"  style={{color: changeColor}}>{periodChangeString}</div>
        </div>
    )
}
